import {
  CURRENT_CONTEXT_CHANGED,
  CURRENT_DOCUMENT_CHANGED,
  ADDED_FILE_TO_TASKLIST,
  CLOSED_FILE_IN_TASKLIST
} from "../actions/types";

/**
 * Reduces incoming FS actions to a new state
 *
 * @param {*} state
 * @param {*} action
 */
export default function fs(state = {}, action = {}) {
  switch (action.type) {
    /**
     * Updates the current context
     */
    case CURRENT_CONTEXT_CHANGED:
      return { ...state, currentContext: action.newContext };
    /**
     * Updates the current document
     */
    case CURRENT_DOCUMENT_CHANGED:
      return {
        ...state,
        currentDocument: action.newDocument,
        currentContext: action.context
      };
    /**
     * Adds the specified file to the task list
     */
    case ADDED_FILE_TO_TASKLIST: {
      const tasklist = JSON.parse(JSON.stringify(state.tasklist || {}));

      if (!tasklist.hasOwnProperty(action.context)) {
        tasklist[action.context] = [];
      }
      const tasks = tasklist[action.context];

      if (tasks.filter(task => task === action.document).length === 0) {
        tasks.push(action.document);
      }
      return {
        ...state,
        tasklist
      };
    }
    /**
     * Removes the specified file from the task list
     */
    case CLOSED_FILE_IN_TASKLIST: {
      const tasklist = JSON.parse(JSON.stringify(state.tasklist || {}));

      if (tasklist.hasOwnProperty(action.context)) {
        tasklist[action.context] = tasklist[action.context].filter(
          task => task !== action.document
        );
      }
      return {
        ...state,
        tasklist
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tasklist.js